module.exports = __webpack_public_path__ + "static/img/active1.2e3a3793.png";